import { Point } from "../../MyHelpers";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import { Resourceful } from "../../ResourceManager/Resourceful";
import { FamilyConstructiveFeature } from "./FamilyConstructiveFeature";
import { FamilyMultiBonusConstructiveFeature } from "./FamilyMultiBonusConstructiveFeature";
import { FamilyConstructivePotPoppet } from "./FamilyConstructivePotPoppet";
import { FamilyParticlesFeature } from "./FamilyParticlesFeature";
import { FillingPotParams } from "./FillinPotParams";
import { IGenericFamilySpine } from "./IGenericFamilySpine";
import { BetConfig } from "../../api";
import { SpinnableReelsBigCanvas } from "../SpinAnimation/SpinnableReelsBigCanvas";
import { PotCollectPosition } from "./CollectSRAPathFillingPot";


export interface IFillinPotFamilyFactory {    
    CreateFamily(familyName : string , params: FillingPotParams , controlScalePoint : Point , poppetPlusPot : boolean , spinnableReels : SpinnableReelsBigCanvas) : IGenericFamilySpine
}

export class FillingPotFamilyFeatureFactory implements IFillinPotFamilyFactory {   
    public CreateFamily(familyName : string ,params: FillingPotParams , controlScalePoint : Point , poppetPlusPot : boolean , spinnableReels : SpinnableReelsBigCanvas) : IGenericFamilySpine {
        if (familyName == "Family-Particles"){            
            return new FamilyParticlesFeature(familyName,params, controlScalePoint);
        }else if (familyName == "Family-Constructive"){
            if(poppetPlusPot == true) return  new FamilyConstructivePotPoppet(familyName,params , controlScalePoint);            
            return  new FamilyConstructiveFeature(familyName,params , controlScalePoint );            
        }else if (familyName == "Family-MultiBonus-Constructive"){
            return  new FamilyMultiBonusConstructiveFeature(familyName,params , controlScalePoint , spinnableReels);            
        }
        throw `Check Family Name: ${familyName}`    
        return null;    
    }  
}